<span
  class="cads-icon-view-bit"
  [class.cads-icon-view-bit--small]="isSmall()"
  [class.cads-icon-view-bit--medium]="isMedium()"
  [class.cads-icon-view-bit--large]="isLarge()"
  [class.cads-icon-view-bit--xlarge]="isXlarge()"
  [class.cads-icon-view-bit--rounded]="isRounded()"
  [class.cads-icon-view-bit--circle]="isCircle()"
  [class.cads-icon-view-bit--icon]="isIconShape()"
  [class.cads-icon-view-bit--dot]="isDot()"
  [class.cads-icon-view-bit--collapsed]="isCollapsed()"
  [class.cads-icon-view-bit--rect-sprite]="hasRectangularSprite()"
  [class.cads-icon-view-bit--palette-ramp]="hasSemanticPaletteRamp() && !isDot()"
  [ngStyle]="cssVars()"
  [attr.role]="accessibleLabelText() ? 'img' : null"
  [attr.aria-label]="accessibleLabelText()"
  [attr.aria-hidden]="accessibleLabelText() ? null : true"
>
  @if (isDot()) {
    <span class="cads-icon-view-bit__dot" aria-hidden="true"></span>
  } @else if (showLabel()) {
    <span class="cads-icon-view-bit__label">{{ effectiveConfig().label }}</span>
  } @else {
    <svg
      class="cads-icon-view-bit__svg"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
    >
      <use [attr.href]="spriteHref()" />
    </svg>
  }
</span>
